module.exports = __webpack_public_path__ + "img/studyBg.e7a6ca62.jpg";